import { render } from "./VposQuenMatKhau.vue?vue&type=template&id=5773dfbf"
import script from "./VposQuenMatKhau.vue?vue&type=script&lang=js"
export * from "./VposQuenMatKhau.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__